import { render, staticRenderFns } from "./IconosHome.vue?vue&type=template&id=01f2d98e&scoped=true"
import script from "./IconosHome.vue?vue&type=script&lang=js"
export * from "./IconosHome.vue?vue&type=script&lang=js"
import style0 from "./IconosHome.vue?vue&type=style&index=0&id=01f2d98e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f2d98e",
  null
  
)

export default component.exports